import styles from './notification-bar.module.scss';
import { NotificationBar as NotificationBarProp } from '../../typescript/component';
import parse, { domToReact, HTMLReactParserOptions, Element } from 'html-react-parser';
import Link from 'next/link';

export default function NotificationBar({
  notification_bar,
}: {
  notification_bar: NotificationBarProp;
}) {
  const stripPTags = (htmlString: string) => {
    const options: HTMLReactParserOptions = {
      replace: node => {
        if (node instanceof Element && node.name === 'p') {
          return <>{domToReact(node.children, options)}</>;
        }
      },
    };
    return parse(htmlString, options);
  };

  const hasNotification = notification_bar && Object.keys(notification_bar).length > 0;

  if (
    !hasNotification ||
    !notification_bar.show_announcement ||
    !notification_bar.announcement_text
  ) {
    return null;
  }

  const classes = [
    styles.announcementBanner,
    // notification_bar.color === 'Dark' ? styles.dark : styles.light
  ];

  if (!notification_bar?.cta_link?.href)
    classes.push(styles.announcementBannerWrapper);

  const content = <>
    {/* Commented for now */}
    {/* {notification_bar.notification_type && (
      <div className={styles.type}>{notification_bar.notification_type}:</div>
    )} */}
    <div className={styles.message}>{stripPTags(notification_bar.announcement_text)}</div>
    {notification_bar?.cta_link?.href && (
      <span className={styles.cta_announcement}>
        {notification_bar.cta_link.title}
      </span>
    )}
  </>

  return (
    <div
      className={classes.join(' ')}
    >
      {notification_bar?.cta_link?.href ? (
        <Link href={notification_bar.cta_link.href} className={styles.announcementBannerWrapper}>
          {content}
        </Link>
      ) : content}
    </div>
  );
}
